import React from 'react';
import { QRCodeSVG } from 'qrcode.react';

interface QRCodeProps {
    uri: string;
}

export const QRCode: React.FC<QRCodeProps> = (props) => {
    const { uri } = props;

    return (
        <QRCodeSVG
            value={uri}
            size={256}
            style={{ alignSelf: 'center' }}
        />
    );
};
